import Generic from "./Generic";

export default class MasterData {
    /**
     * academic related codes
     */
    static studyPeriodInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();
    }

}
